const TRANSIENT_UPLOAD_STATUSES = new Set([502, 503, 504]);
const TRANSIENT_UPLOAD_CODES = new Set(['ERR_NETWORK', 'ECONNRESET', 'ETIMEDOUT']);

export const DEFAULT_UPLOAD_RETRY_DELAY_MS = 800;

export function isTransientUploadError(error) {
  const status = error?.response?.status;
  const code = error?.code;

  return TRANSIENT_UPLOAD_STATUSES.has(status) || TRANSIENT_UPLOAD_CODES.has(code);
}

export function delayUploadRetry(ms = DEFAULT_UPLOAD_RETRY_DELAY_MS) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function postUploadWithRetry(
  axiosClient,
  url,
  formData,
  options,
  {
    maxRetries = 1,
    retryDelayMs = DEFAULT_UPLOAD_RETRY_DELAY_MS,
    delayFn = delayUploadRetry,
  } = {}
) {
  let attempt = 0;
  let lastError;

  while (attempt <= maxRetries) {
    try {
      const response = await axiosClient.post(url, formData, options);
      response.uploadRetryCount = attempt;
      return response;
    } catch (error) {
      lastError = error;

      if (attempt >= maxRetries || !isTransientUploadError(error)) {
        error.uploadRetryCount = attempt;
        throw error;
      }

      attempt += 1;
      await delayFn(retryDelayMs, attempt, error);
    }
  }

  throw lastError;
}
